import { z } from 'zod'

export const MAX_USER_IMAGE_SIZE = 1024 * 1024 * 3 // 3MB

export const PasswordSchema = z
  .string({ required_error: 'errors.user.password.required' })
  .min(8, { message: 'errors.user.password.tooShort' })
  .max(100, { message: 'errors.user.password.tooLong' })
export const FirstNameSchema = z
  .string({ required_error: 'errors.user.firstName.required' })
  .min(2, { message: 'errors.user.firstName.tooShort' })
  .max(40, { message: 'errors.user.firstName.tooLong' })
export const LastNameSchema = z
  .string({ required_error: 'errors.user.lastName.required' })
  .min(2, { message: 'errors.user.lastName.tooShort' })
  .max(40, { message: 'errors.user.lastName.tooLong' })
export const EmailSchema = z
  .string({ required_error: 'errors.user.email.required' })
  .email({ message: 'errors.user.email.invalid' })
  .min(3, { message: 'errors.user.email.tooShort' })
  .max(100, { message: 'errors.user.email.tooLong' })
  // users can type the email in any case, but we store it in lowercase
  .transform(value => value.toLowerCase())

export const PasswordAndConfirmPasswordSchema = z
  .object({
    password: PasswordSchema,
    confirmPassword: PasswordSchema,
    email: EmailSchema,
  })
  .superRefine(({ confirmPassword, password }, ctx) => {
    if (confirmPassword !== password) {
      ctx.addIssue({
        path: ['confirmPassword'],
        code: 'custom',
        message: 'errors.user.password.doNotMatch',
      })
    }
  })
